import { Component } from '@angular/core';
import { NgIf, NgOptimizedImage } from '@angular/common';
import { ChatService } from '@obo-main/components/chatBot/services/chat.service';
import { MobileNavigationService } from '@obo-main/services/mobileNavigation/mobile-navigation.service';

@Component({
    selector: 'app-chatbot-open-button',
    imports: [NgIf, NgOptimizedImage],
    templateUrl: './chatbot-open-button.component.html',
    styleUrl: './chatbot-open-button.component.scss'
})
export class ChatbotOpenButtonComponent {
    constructor(protected chatService: ChatService, protected mobileNavigationService: MobileNavigationService) {}
}
